import Box from '@mui/material/Box';
import {
  GeographicOption,
  type GeographicTargetingState,
  type RadiusCircle,
} from '@openx/types/targeting/geographic.ts';
import { Criteria } from '@openx/types/targeting/targetingValuesTypes.ts';
import { getCircleDisplayName } from '@openx/utils/state/geoLocationSearch/utils.ts';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { DimensionChipLine } from '../../shared/DimensionChip/DimensionChipLine.tsx';
import { FiltersTitle } from '../../shared/FiltersTitle/FiltersTitle.tsx';
import { SelectedItems } from '../../shared/SelectedItems/SelectedItems.tsx';

type CirclesItemsProps = {
  isNotLastItem: boolean;
  onChange: (newData: GeographicTargetingState) => void;
  readonly: boolean;
  targetingParams: GeographicTargetingState;
  disabledReasonMessage?: string;
};

export const CirclesItems = ({
  isNotLastItem,
  onChange,
  readonly,
  targetingParams,
  disabledReasonMessage,
}: CirclesItemsProps) => {
  const { t } = useTranslation();
  const { circles_v2 } = targetingParams;
  const circlesCount = circles_v2.length;

  const onCirclesClear = useCallback(() => {
    onChange({ ...targetingParams, [GeographicOption.CIRCLES]: [] });
  }, [onChange, targetingParams]);

  const onCircleRemove = useCallback(
    (filteredItems: RadiusCircle[]) => {
      onChange({ ...targetingParams, [GeographicOption.CIRCLES]: filteredItems });
    },
    [onChange, targetingParams]
  );

  return (
    <Box data-test="sub-section">
      <FiltersTitle
        onClear={onCirclesClear}
        title={t('Location Radius [ {count} ]', { count: circlesCount })}
        readonly={readonly}
        disabledReasonMessage={disabledReasonMessage}
      />

      <SelectedItems
        filtersTitle={t('include')}
        isAddIcon
        selectedItems={circles_v2}
        readonly={readonly}
        handleChange={onCircleRemove}
        isRemovingAll
        getItemLabel={getCircleDisplayName}
        dataTest="circles-v2"
      />

      {isNotLastItem && <DimensionChipLine targetingDimension={Criteria.ANY} />}
    </Box>
  );
};
